import cookie from 'cookie'

export const set = (name, value, options) => {
  document.cookie = cookie.serialize(name, value, options)
}

export const get = name => {
  return cookie.parse(document.cookie)[name]
}
export default {
  set,
  get,
}
